import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MatchDetailsPageRoutingModule } from './match-details-routing.module';

import { MatchDetailsPage } from './match-details.page';
import { MatchTrackerPageModule } from '../../match-tracker/match-tracker.module';
import { TieMatchListModule } from '../../ties/tie-details/tie-match-list/tie-match-list.module';
import { TieScorecardModule } from '../../ties/tie-details/tie-scorecard/tie-scorecard.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        MatchDetailsPageRoutingModule,
        MatchTrackerPageModule,
        TieMatchListModule,
        TieScorecardModule
    ],
    declarations: [
        MatchDetailsPage,
    ]
})

export class MatchDetailsPageModule {}
